import React, { useState, useEffect, useContext } from 'react';
import 'react-toastify/dist/ReactToastify.css';

export const CartContext = React.createContext([]);

export const useCartContext = () => useContext(CartContext);


export function CartProvider({ children }) {
  //estado de productos agregados con conexion a localStorage!
  const [items, setItems] = useState(localStorage.getItem('Items')
                                        ? JSON.parse(localStorage.getItem('Items'))
                                        : []);

  const [itemWish, setItemWish] = useState(localStorage.getItem('ItemWish')
                                        ? JSON.parse(localStorage.getItem('ItemWish'))
                                        : [])

  const[tost, setTost] = useState(false)
  const [vacio, setVacio]= useState(false)
  const [yaEsta, setYaEsta] = useState(false)

  useEffect(() => {
    //Envia a localStorage para su guardado temporal!
    localStorage.setItem('Items', JSON.stringify(items));
    localStorage.setItem('ItemWish', JSON.stringify(itemWish));
  }, [items,itemWish, yaEsta]);


  //si el producto esta o no en el carrito devuelve true || false.
  const isInCart=(id)=>{
    const enElCart = items.some(x=>x.id === id);
    
    return enElCart;
      
  }

  //si ya esta realiza un filtro con un mapeo para solo sumar la cantidad nueva.
  const getQuantity=(datos,count)=>{
    const filtro = [...items];
      filtro.forEach(i => {
        if(i.id === datos.id){
          if((i.qty += count) > 5){
            i.qty = 5 
            setTost(true) 
          }
             
        }  
    })
    setItems(filtro);
  }


 //agrega el producto al carrito y si ya esta, manda la info a cantidad.
  const addItems = (count, datos) => {
    if(isInCart(datos.id)){
      getQuantity(datos,count)
    }
    else{
      if(items.length < 4){
        setItems([...items, {...datos, qty: count}]);
      }
    }
    setVacio(true)
  };
  
//agrega el producto a la lista de deseo
  const addItemWish =(dato)=>{
    const yaEnWish = itemWish.some(x=>x.id === dato.id);
    if(yaEnWish){
      setYaEsta(true)
    }else{
      setYaEsta(false)
     setItemWish([...itemWish, {... dato, qty:1}]) 
    }
    
  }

  // quiere lo guardo lo envia al carrito
  const deseoAcarrito =()=>{
  setItems(items.concat(itemWish))
  setItemWish([])
}

  //suma el total resolviendo precio por cantidad.
  function total (){
    const preciTotal = items.reduce((a,b)=>(a + (b.precio * b.qty)),0)
    
    return preciTotal;
  }

  //suma las cantiades para ser mostrada en el conteo del icono carrito.
  function getUnits(){
    const unid = items.reduce((a,b)=>(a + b.qty),0)
    if(unid == 0){
      setVacio(false)
    }else{
      setVacio(true)
    }
    return unid;
  }

  //borra un producto del carrito .
  const removeItems = (item) => {
    const newItems = items.filter(x=> x.id !== item);
    setItems(newItems);
  };

  //remueve el producto de la lista de deseo
  const removeItemWish = (item) => {
    const newItemWish = itemWish.filter(x=> x.id !== item);
    setItemWish(newItemWish);
  }

  //borra todos los productos del carrito.
  const clearItems = () =>{
    setItems([])
   setVacio(false);
  } 

  

  return (
    <CartContext.Provider value={{ items, addItems, removeItems, clearItems, total, getUnits, tost, vacio, addItemWish, itemWish, removeItemWish, deseoAcarrito, yaEsta }}>
      {children}
    </CartContext.Provider>
  );
}